import React, {useState} from 'react';
import {Stack} from '@mui/material';
import withMainContainer from '../components/WithMainContainer.js';


// WIP
const NumerologyCalculator = ()=>{
    let [birthDate, setBirthDate] = useState(new Date());
    console.log({birthDate})
    return null;
};

export default withMainContainer(NumerologyCalculator);
